const $infoSchemaSection = $('.info-schema');
const $infoSchemaSvg     = $('.info-schema-svg');

export function addAnimationClassOnScroll(curScrollTop) {
  // const infoSchemaSectionTop = $infoSchemaSection.offset().top;
  // console.log(infoSchemaSectionTop);
  // console.log(curScrollTop);
  // if (curScrollTop >= infoSchemaSectionTop) {
    $infoSchemaSvg.addClass('animated');
  // }
}



// WEBPACK FOOTER //
// ./js/animations.js